<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="roleValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :error="errors.get('name')">
            </base-input>

            <base-checkbox class="mb-3"
                    v-model="value.meta.selectable_by_supervisors">
                {{ $t('roles.selectable-by-supervisors') }}
            </base-checkbox>
            
            <div class="mt-4 mb-4">
                <h4 class="card-title mb-2">{{ $t('common.permissions') }}</h4>
                <base-checkbox v-for="(permission, index) in permissions" :key="index"
                        v-model="value.permissions[permission.key]" class="mb-2">
                    {{ permissionName(permission) }}
                </base-checkbox>
            </div>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {
        
        props: ['value', 'errors', 'modal', 'permissions'],

        created() {
            this.errors.setValidator('roleValidator', this)
        },

        methods: {

            permissionName(permission) {
                return permission.name
            },

            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
